// Photothèque réelle des chantiers Termite Habitat 33 en Gironde.
// Chaque entrée comporte un titre, une description SEO et une catégorie.
// Catégories : "Essaimage", "Cordonnets", "Pièges-appâts", "Bois infesté",
// "Charpente", "Cave & humidité", "Communication", "Chantier".

export const PHOTO_CATEGORIES = [
  "Tous",
  "Essaimage",
  "Cordonnets",
  "Pièges-appâts",
  "Bois infesté",
  "Charpente",
  "Cave & humidité",
  "Communication",
  "Chantier",
];

export const PHOTOS = [
  {
    src: "https://customer-assets.emergentagent.com/job_wonderful-greider-8/artifacts/1gibmqar_20250211_164903.jpg",
    title: "Essaimage de termites au pied d'une plinthe",
    description:
      "Centaines de termites ailés (reproducteurs) au sol après essaimage en intérieur. Découverte typique en hiver/printemps qui révèle une colonie installée dans la structure depuis plusieurs années. Bordeaux — février 2025.",
    cat: "Essaimage",
    date: "2025-02-11",
    location: "Gironde",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_wonderful-greider-8/artifacts/hsnkibvl_20250211_180619.jpg",
    title: "Cordonnet de termites le long d'un plafond",
    description:
      "Tube de terre agglomérée construit par les termites souterrains pour relier le sol au bois supérieur sans exposition à la lumière. Signe le plus caractéristique d'une infestation active. Intervention Gironde — février 2025.",
    cat: "Cordonnets",
    date: "2025-02-11",
    location: "Gironde",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_wonderful-greider-8/artifacts/h9ms8dul_20251029_101631.jpg",
    title: "Panneau Termite Habitat 33 — secteur Gironde",
    description:
      "Panneau d'information Termite Habitat 33 installé en Gironde : intervention rapide sur tout le département, devis gratuit. Cabinet local de proximité.",
    cat: "Communication",
    date: "2025-10-29",
    location: "Gironde",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_wonderful-greider-8/artifacts/3li5ls8q_20251118_100246.jpg",
    title: "Station de piège-appât avec termites en activité",
    description:
      "Ouverture d'une station de surveillance et d'appât en périmètre extérieur. Plusieurs termites ouvriers blanchâtres sont en train de consommer le bois-appât : preuve d'une colonie active à proximité du bâtiment.",
    cat: "Pièges-appâts",
    date: "2025-11-18",
    location: "Gironde",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_wonderful-greider-8/artifacts/cdk0hj9b_20251128_155233.jpg",
    title: "Cordonnet sur poutre de cave bordelaise",
    description:
      "Long cordonnet de terre descendant le long d'une poutre ancienne en cave. La colonie souterraine remonte par capillarité jusqu'à la solive supérieure : signal d'alarme pour le bâti.",
    cat: "Cordonnets",
    date: "2025-11-28",
    location: "Bordeaux",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_wonderful-greider-8/artifacts/syyborch_20251128_160539.jpg",
    title: "Boîtier Termigard Wall Box posé sur poutre de cave",
    description:
      "Installation d'une station Termigard System « Wall Box » directement sur une poutre ancienne fortement dégradée en cave. Le boîtier permet la pose d'un appât de surveillance au plus près du passage des termites.",
    cat: "Pièges-appâts",
    date: "2025-11-28",
    location: "Gironde",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_wonderful-greider-8/artifacts/syaz4v1t_20251205_112952.jpg",
    title: "Station d'appât extérieure colonisée par les termites",
    description:
      "Ouverture d'une station d'appât posée au sol extérieur dans une pelouse girondine. Bois-appât consommé par les termites souterrains — colonie active confirmée en périphérie du bâtiment.",
    cat: "Pièges-appâts",
    date: "2025-12-05",
    location: "Gironde",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_wonderful-greider-8/artifacts/zivziepl_20251209_102311.jpg",
    title: "Barrière chimique périphérique — injection en pied de mur",
    description:
      "Trous d'injection rebouchés alignés en pied de mur extérieur après création d'une barrière chimique anti-termites. Protocole préventif et curatif pour empêcher les remontées de colonies du sol vers la structure.",
    cat: "Chantier",
    date: "2025-12-09",
    location: "Gironde",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_wonderful-greider-8/artifacts/l4v22ckd_20260114_104222.jpg",
    title: "Termites ouvriers à découvert dans un bois infesté",
    description:
      "Gros plan sur des termites souterrains (Reticulitermes flavipes) à la surface d'un bois dégradé. Ouvriers blanchâtres caractéristiques en pleine activité, sciure et débris autour.",
    cat: "Bois infesté",
    date: "2026-01-14",
    location: "Gironde",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_wonderful-greider-8/artifacts/pdgge4hw_20260114_104325.jpg",
    title: "Termites au sol après ouverture du bois colonisé",
    description:
      "Plusieurs termites visibles au sol après ouverture d'un morceau de bois en surface. Indication d'une colonie souterraine bien installée à proximité immédiate du bâti.",
    cat: "Bois infesté",
    date: "2026-01-14",
    location: "Gironde",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_wonderful-greider-8/artifacts/6ajwjr75_20260225_114520.jpg",
    title: "Traitement de charpente sous toiture en tuiles canal",
    description:
      "Technicien Termite Habitat 33 en combinaison de protection intervenant sur une poutre de charpente, sous une toiture traditionnelle en tuiles canal romanes. Perçages réguliers visibles pour injection à cœur du bois.",
    cat: "Charpente",
    date: "2026-02-25",
    location: "Gironde",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_wonderful-greider-8/artifacts/ypemmrtr_20260309_114928.jpg",
    title: "Cordonnet sur mur en pierre bordelaise",
    description:
      "Long cordonnet de terre montant verticalement sur un mur en pierre calcaire blonde typique du bâti bordelais, au-dessus d'une porte. Voie de circulation construite par les termites pour rejoindre le bois en hauteur.",
    cat: "Cordonnets",
    date: "2026-03-09",
    location: "Bordeaux",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_wonderful-greider-8/artifacts/6amugl07_20260331_104629.jpg",
    title: "Encadrement de porte attaqué — bois mis à nu",
    description:
      "Chambranle de porte intérieur dont la peinture s'effondre et révèle un bois noirci et galérié par les termites. Dégât typique d'une infestation discrète en pièce d'habitation.",
    cat: "Bois infesté",
    date: "2026-03-31",
    location: "Gironde",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_wonderful-greider-8/artifacts/rd4fo0tg_20260504_111552.jpg",
    title: "Cordonnets de termites au plafond — dalle attaquée",
    description:
      "Cordonnets de terre serpentant sous une dalle de faux plafond, partie centrale rongée laissant apparaître la structure. Les termites circulent depuis l'étage supérieur ou les combles.",
    cat: "Cordonnets",
    date: "2026-05-04",
    location: "Gironde",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_wonderful-greider-8/artifacts/n6e14qzg_20260518_102759.jpg",
    title: "Ouverture d'une station d'appât extérieure colonisée",
    description:
      "Vue en plongée d'une station de surveillance ouverte au sol : le bois-appât est rongé et des termites ouvriers sont visibles. La cavité circulaire reçoit ensuite la matrice insecticide pour transmission à toute la colonie.",
    cat: "Pièges-appâts",
    date: "2026-05-18",
    location: "Gironde",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_wonderful-greider-8/artifacts/e3413b7af7a66aed_20260518_102801.webp",
    title: "Gros plan sur termites ouvriers dans la station d'appât",
    description:
      "Vue zoomée sur une station Termigard System ouverte : plusieurs termites ouvriers blanchâtres sont visibles sur le bois-appât rongé, le piège circulaire est colonisé. Preuve directe de l'activité d'une colonie Reticulitermes à proximité immédiate d'une habitation girondine.",
    cat: "Pièges-appâts",
    date: "2026-05-18",
    location: "Gironde",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_wonderful-greider-8/artifacts/rdmkyhqf_20260129_101344.jpg",
    title: "Réseau de stations d'appâts au jardin",
    description:
      "Alignement de stations Termigard System enterrées dans la pelouse autour d'une maison girondine. Pose en périmètre pour détecter et éliminer toute colonie souterraine avant qu'elle n'atteigne la maison.",
    cat: "Pièges-appâts",
    date: "2026-01-29",
    location: "Gironde",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_wonderful-greider-8/artifacts/pdkt3qul_20260225_110933.jpg",
    title: "Intervention sur un bandeau de rive extérieur",
    description:
      "Technicien Termite Habitat 33 en combinaison de protection sur échelle, traitant le bandeau de rive d'une terrasse couverte. Injection préventive des bois exposés aux remontées termites.",
    cat: "Chantier",
    date: "2026-02-25",
    location: "Gironde",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_wonderful-greider-8/artifacts/cn6fr4u2_20260225_110939.jpg",
    title: "Injection en sous-toiture par notre technicien",
    description:
      "Vue rapprochée du technicien en cours de perçage et d'injection de produit insecticide rémanent dans le bandeau de rive sous la couverture en tuiles. Maillage d'injections régulier conforme au protocole CTB-P+.",
    cat: "Chantier",
    date: "2026-02-25",
    location: "Gironde",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_wonderful-greider-8/artifacts/qddfzl9t_20260225_111124.jpg",
    title: "Chevilles d'injection alignées sur planche de rive",
    description:
      "Gros plan sur les perçages d'injection rebouchés par des chevilles plastique, alignés sur la planche de rive après traitement curatif. Maillage de 25-30 cm permettant une saturation à cœur du bois.",
    cat: "Charpente",
    date: "2026-02-25",
    location: "Gironde",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_wonderful-greider-8/artifacts/a6w0cg2r_20260225_111132.jpg",
    title: "Bandeau de rive traité — vue d'ensemble",
    description:
      "Vue d'ensemble d'un bandeau de rive après traitement préventif/curatif des bois extérieurs. Les chevilles d'injection encore visibles attestent du maillage serré utilisé pour protéger durablement la charpente.",
    cat: "Charpente",
    date: "2026-02-25",
    location: "Gironde",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_wonderful-greider-8/artifacts/q0twuqfg_20260114_104331.jpg",
    title: "Termites groupés sur bois fortement dégradé",
    description:
      "Concentration de termites ouvriers sur un morceau de bois colonisé, prise quelques secondes après la photo précédente. Le bois s'effrite en filaments et révèle l'ampleur du réseau de galeries internes.",
    cat: "Bois infesté",
    date: "2026-01-14",
    location: "Gironde",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_wonderful-greider-8/artifacts/8qkm7bdw_IMG_20250218_205951.jpg",
    title: "Termites circulant sur mur de cave en pierre",
    description:
      "Larves et ouvriers termites observés directement sur un mur de cave girondine en pierre et galets — moellons typiques des fondations bordelaises anciennes. La colonie remonte du sol par les joints poreux : indice classique d'humidité chronique en sous-sol.",
    cat: "Cave & humidité",
    date: "2025-02-18",
    location: "Bordeaux",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_wonderful-greider-8/artifacts/656f6699d455ff83_images%20%2818%29.jpeg",
    title: "Grande colonie de termites — ouvriers et soldats",
    description:
      "Vue rapprochée d'une colonie dense de termites souterrains : des centaines d'ouvriers blanchâtres et quelques soldats reconnaissables à leurs mandibules orangées. Cette caste défensive protège la reine et les œufs lorsque la colonie est perturbée.",
    cat: "Bois infesté",
    date: "2026-07-01",
    location: "Gironde",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_wonderful-greider-8/artifacts/e7e97c501de422b7_Degats4jpg_5bd890ba1a57f.jpg",
    title: "Cordonnet descendant d'une poutre au plafond",
    description:
      "Cordonnet de terre spectaculaire construit par les termites souterrains le long d'une poutre apparente en chêne. Les tunnels agglomérés permettent aux ouvriers de rejoindre le bois nourricier à l'abri de la lumière et de la dessiccation.",
    cat: "Cordonnets",
    date: "2026-07-01",
    location: "Gironde",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_wonderful-greider-8/artifacts/de8672939747f7f9_IMG72512JPG_633ef2a349150.jpeg",
    title: "Essaimage massif de termites au pied d'une porte",
    description:
      "Nuée impressionnante de termites ailés (reproducteurs) après essaimage printanier au pied d'une porte intérieure. Signe caractéristique d'une colonie mature installée dans la structure depuis plusieurs années — intervention urgente conseillée.",
    cat: "Essaimage",
    date: "2026-07-01",
    location: "Gironde",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_wonderful-greider-8/artifacts/0afa74fd0f5b3bc8_images%20%2814%29.jpeg",
    title: "Cordonnet horizontal au-dessus d'une plinthe",
    description:
      "Tube de terre fin construit horizontalement sur le haut d'une plinthe. Les termites choisissent souvent les joints et interstices pour franchir les discontinuités du bâti — ce type de cordonnet reste discret et passe facilement inaperçu lors d'une inspection rapide.",
    cat: "Cordonnets",
    date: "2026-07-01",
    location: "Gironde",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_wonderful-greider-8/artifacts/a7d07a2e2f8b50b5_images%20%2819%29.jpeg",
    title: "Termites creusant un bois en décomposition",
    description:
      "Vue détaillée de termites ouvriers en pleine activité sur une pièce de bois fortement dégradée. Le bois présente la structure fibreuse caractéristique du bois attaqué : couche superficielle intacte, cœur entièrement galérié et transformé en poussière.",
    cat: "Bois infesté",
    date: "2026-07-01",
    location: "Gironde",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_wonderful-greider-8/artifacts/a4f93651c38c025a_images%20%2812%29.jpeg",
    title: "Sondage d'une charpente infestée au tournevis",
    description:
      "Expertise d'une poutre de cave par sondage acoustique au tournevis. Le bois apparent est effiloché, blanchi par l'humidité et profondément attaqué sur toute sa longueur. Le son creux au sondage confirme l'évidement interne et l'ampleur des galeries de termites.",
    cat: "Charpente",
    date: "2026-07-01",
    location: "Gironde",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_wonderful-greider-8/artifacts/322b0bee520cf3c3_termites-actively-digging-through-rich-soil-in-a-vibrant-underground-environment-at-dawn-photo.jpeg",
    title: "Termite ouvrier creusant une galerie souterraine",
    description:
      "Vue macro spectaculaire d'un termite ouvrier (Reticulitermes flavipes) progressant dans la terre meuble. Les colonies souterraines étendent leur réseau de galeries jusqu'à 100 mètres autour du nid, à la recherche permanente de nouvelles sources de cellulose.",
    cat: "Bois infesté",
    date: "2026-07-01",
    location: "Gironde",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_wonderful-greider-8/artifacts/e28ae06f89936961_CNRS_20190002_0014_60454.jpg",
    title: "Soldats termites à mandibules orangées — gros plan",
    description:
      "Vue scientifique en très gros plan de deux soldats termites, reconnaissables à leur tête massive et à leurs mandibules allongées orangées. La caste des soldats défend la colonie contre les fourmis et les intrusions. Elle ne représente que 2 à 5 % de l'effectif total.",
    cat: "Bois infesté",
    date: "2026-07-01",
    location: "Gironde",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_wonderful-greider-8/artifacts/95cf8a428b3ebc21_images%20%287%29.jpeg",
    title: "Termite ailé — essaimage printanier en vue rapprochée",
    description:
      "Portrait d'un termite reproducteur ailé (imago) après essaimage. Au printemps, chaque colonie mature libère des milliers de ces individus porteurs d'ailes qui s'envolent pour fonder de nouveaux foyers. Leurs ailes se détachent après le vol nuptial.",
    cat: "Essaimage",
    date: "2026-07-01",
    location: "Gironde",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_wonderful-greider-8/artifacts/e083b88026a7dcba_images%20%2810%29.jpeg",
    title: "Piège-appât extérieur ouvert — pose en périmètre",
    description:
      "Station de surveillance Termigard System installée au ras de la pelouse, en limite de maison. L'ouverture circulaire du couvercle permet d'inspecter rapidement l'état du bois-appât et de confirmer la présence éventuelle de termites consommateurs.",
    cat: "Pièges-appâts",
    date: "2026-07-01",
    location: "Gironde",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_wonderful-greider-8/artifacts/d640fe49586cc02e_20260518_104818.webp",
    title: "Barrière chimique en pied de mur — injection sol/mur",
    description:
      "Perforations régulières réalisées en pied d'une façade girondine en pierre pour l'injection d'une barrière chimique anti-termites. Les chevilles blanches obturent chaque trou après injection du produit insecticide dans la maçonnerie, interdisant toute remontée souterraine. Chantier mai 2026.",
    cat: "Chantier",
    date: "2026-05-18",
    location: "Gironde",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_wonderful-greider-8/artifacts/cc76e11eede7815d_20260609_104504.webp",
    title: "Charpente ancienne traitée par injection — poutres marquées",
    description:
      "Sous-pente d'une maison girondine équipée d'une charpente ancienne en chêne. Les points blancs visibles sur la poutre maîtresse correspondent aux chevilles d'injection posées après traitement curatif : chaque percement a reçu une dose d'insecticide xylophage profondément dans la masse du bois.",
    cat: "Charpente",
    date: "2026-06-09",
    location: "Gironde",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_wonderful-greider-8/artifacts/199e174d28013430_20260609_104509.webp",
    title: "Linteau bois extérieur — injection sous auvent",
    description:
      "Linteau en bois ancien d'une porte d'entrée protégé par un auvent traditionnel bordelais. Les chevilles d'obturation régulièrement espacées sur toute la longueur signalent un traitement curatif par injection : garantie 5 ans — retraitement gratuit en cas de nouvelle infestation.",
    cat: "Chantier",
    date: "2026-06-09",
    location: "Gironde",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_wonderful-greider-8/artifacts/6424d54db8269864_20260703_101403.webp",
    title: "Bois extérieur rongé — galeries ouvertes et bois pulvérulent",
    description:
      "Pièce de bois extérieure posée au sol présentant un évidement caractéristique : galeries internes, bois pulvérulent, fibres délitées en surface. Preuve typique d'une colonie de termites souterrains Reticulitermes active à proximité de la maison. Inspection Gironde — juillet 2026.",
    cat: "Bois infesté",
    date: "2026-07-03",
    location: "Gironde",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_wonderful-greider-8/artifacts/8f74278da4e56908_20260703_103735.webp",
    title: "Volet bois ancien perforé — infestation structurelle avancée",
    description:
      "Vue rapprochée d'un volet bois ancien percé de part en part par les termites : galeries internes exposées, matière pulvérulente, perte totale de résistance mécanique. Dégât structurel visible après longue colonisation. Expertise sur maison girondine — juillet 2026.",
    cat: "Bois infesté",
    date: "2026-07-03",
    location: "Gironde",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_wonderful-greider-8/artifacts/5828738159369ebf_20260821_094438.webp",
    title: "Piquet bois extérieur colonisé — termites ouvriers visibles",
    description:
      "Piquet de bois planté dans l'herbe au bord d'une propriété girondine, colonisé de bas en haut par les termites souterrains. Les ouvriers blanchâtres remontent du sol via le piquet-témoin, signe fort d'une activité à proximité immédiate. Inspection terrain — août 2026.",
    cat: "Bois infesté",
    date: "2026-08-21",
    location: "Gironde",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_wonderful-greider-8/artifacts/82fc48c815602dfe_20260908_083642.webp",
    title: "Station d'appât Termigard — bois crénelé consommé par les termites",
    description:
      "Ouverture d'une station de surveillance Termigard System en périmètre : le bois-appât en forme de cannelures est fortement consommé, plusieurs termites ouvriers visibles sur le pourtour de la station. Validation visuelle avant mise en place de la matrice d'élimination. Chantier Gironde — septembre 2026.",
    cat: "Pièges-appâts",
    date: "2026-09-08",
    location: "Gironde",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_wonderful-greider-8/artifacts/6ab34e11f00eedf0_20260908_083701.webp",
    title: "Cœur d'une station d'appât — vue zénithale sur les termites",
    description:
      "Plongée macro à l'intérieur du cylindre creux d'une station d'appât anti-termites : résidus de bois rongé, grains de sable et termites ouvriers blanchâtres au fond. Témoin direct de l'activité d'une colonie souterraine captée en Gironde — septembre 2026.",
    cat: "Pièges-appâts",
    date: "2026-09-08",
    location: "Gironde",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_wonderful-greider-8/artifacts/23b2781b9a256fe8_file_000000006a6c81f4a1c93e992520ed79.png",
    title: "Anatomie de la termite — infographie pédagogique",
    description:
      "Planche pédagogique Termite Habitat 33 détaillant l'anatomie d'une termite Reticulitermes flavipes : tête (antennes, mandibules, yeux), thorax (3 paires de pattes, griffes), abdomen (segments, cerques). Taille 4–12 mm, couleur blanc à brun clair, mode de vie en colonie (ouvrières, soldats, reproducteurs), régime cellulose. Un petit insecte, de grands dégâts.",
    cat: "Communication",
    date: "2026-10-07",
    location: "Gironde",
  },
];

export const getPhotosByCategory = (cat) =>
  cat === "Tous" || !cat ? PHOTOS : PHOTOS.filter((p) => p.cat === cat);
